/**
 * ファイルツリー・問題パネル・モニタ・検索結果・チャット一覧など、選択可能な一覧行で
 * 共通の濃度。選択をホバーより一段濃くすることで、枠なしでも順序で読める。
 */
export const ROW_HOVER_BG = "var(--row-hover-bg)";
export const ROW_SELECTED_BG = "var(--row-selected-bg)";
export const ROW_HOVER_CLASS = "hover:bg-row-hover-bg";
export const ROW_SELECTED_CLASS = "bg-row-selected-bg";

/** ドロップ先は選択ではなく一時的な誘導なので、アクセントの色のまま強く出す。 */
export const TREE_ROW_DRAGOVER_CLASS =
	"bg-row-dragover-bg outline outline-row-dragover-line [outline-offset:-1px]";
